import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// Screens
import Landing from "./screens/Landing.jsx";
import BookingAgentDetails from "./screens/BookingAgentPage.jsx";
import ChatBotDetails from "./screens/ChatBotPage.jsx";
import ATSDetails from "./screens/ATSPage.jsx";
import RequirementForgeAgent from "./screens/RequirementForgeAgent.jsx";
import GoogleRoute from "./screens/GoogleRouteAgent.jsx";
import NotFound from "./screens/NotFound.jsx";
import TopNavbar from "./components/Nav/TopNavbar.jsx";
import Footer from "./components/Sections/Footer.jsx";
// firebase
import { getToken } from "firebase/messaging";
import { messaging } from "./config/firebase.js";
import ResumeAnalyseChatBotAgent from "./screens/ResumeAnalyseChatBotAgent.jsx";
import FinanceTrackerPage from "./screens/FinanceTrackerPage.jsx";
import VideoStreamingPage from "./screens/VideoStreamingPage.jsx";
import UrbanFarmingPage from "./screens/UrbanFarmingPage.jsx";
import QuizorraPage from "./screens/QuizorraPage.jsx";
import UlcerSightPage from "./screens/UlcerSightPage.jsx";
import AISalesTrainingPage from "./screens/AISalesTrainingPage.jsx";
import WalkthroughTrainingSystemPage from "./screens/WalkthroughTrainingSystemPage.jsx";
import BookDemo from "./screens/BookDemo.jsx";

import { useHistory, Redirect, useLocation } from "react-router-dom";

const HiddenLanding = () => {
  const history = useHistory();
  useEffect(() => {
    sessionStorage.setItem("ct-access", "true");
    document.cookie = "ct-access=true; path=/";
    // Use React Router to safely disguise the URL while maintaining state for the back button
    history.replace("/", { fromCtAccess: true });
  }, [history]);
  return null; // The actual rendering will be handled by the "/" route
};

const GlobalRouteProtector = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // Check if the current route is public
    const isPublicRoute = location.pathname === "/" || location.pathname === "/ct-access";
    
    // If it's a private route and the user doesn't have access, redirect to /
    if (!isPublicRoute && sessionStorage.getItem("ct-access") !== "true") {
      history.replace("/");
    }

    // Ensure the cookie is removed if the session is cleared or invalid
    if (sessionStorage.getItem("ct-access") !== "true") {
      document.cookie = "ct-access=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }, [location, history]);

  return null;
};

export default function App() {
  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BHzdRjgHpSBaUeItTg7tLl-je4oppJIrkKznNBVA0nR94xTJN4ZxxMa3kWzaMN9EX20TGNTo24Y7u9-8-fObS2o",
      });

      //We can send token to server
      console.log("Token generated : ", token);
      sessionStorage.setItem("token", token);
    } else if (permission === "denied") {
      //notifications are blocked
      alert("You denied for the notification");
    }
  }

  useEffect(() => {
    requestPermission();
  }, []);

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <BrowserRouter>
        <GlobalRouteProtector />
        <TopNavbar />
        <Switch>
          <Route 
            exact 
            path="/" 
            render={({ location }) => {
              if (location.state && location.state.fromCtAccess) {
                return <Landing />;
              }
              return <BookDemo />;
            }} 
          />
          <Route exact path="/ct-access" component={HiddenLanding} />
          <Route
            exact
            path="/ai-demo/booking-agent"
            component={BookingAgentDetails}
          />
          <Route exact path="/ai-demo/chat-bot" component={ChatBotDetails} />
          <Route exact path="/ai-demo/ats-demo" component={ATSDetails} />
          <Route
            exact
            path="/ai-demo/requirement-forge-demo"
            component={RequirementForgeAgent}
          />
          <Route
            exact
            path="/ai-demo/google-map-route-demo"
            component={GoogleRoute}
          />
          <Route
            exact
            path="/ai-demo/resume-analyse-chat-bot"
            component={ResumeAnalyseChatBotAgent}
          />
          <Route
            exact
            path="/ai-demo/expense-tracker"
            component={FinanceTrackerPage}
          />
          <Route
            exact
            path="/ai-demo/video-streaming-platform"
            component={VideoStreamingPage}
          />
          <Route
            exact
            path="/ai-demo/urban-farming"
            component={UrbanFarmingPage}
          />
          <Route
            exact
            path="/ai-demo/quizorra"
            component={QuizorraPage}
          />
          <Route
            exact
            path="/ai-demo/ulcer-sight"
            component={UlcerSightPage}
          />
          <Route
            exact
            path="/ai-demo/ai-sales-training"
            component={AISalesTrainingPage}
          />
          <Route
            exact
            path="/ai-demo/walkthrough-training-system"
            component={WalkthroughTrainingSystemPage}
          />
          <Route path="*" component={NotFound} />
        </Switch>
        <Footer />
      </BrowserRouter>
    </>
  );
}
